<template>
  <div class="icon-selector mb-2">
    <div class="icon-selector__item" v-for="(icon, iconsIndex) in icons" :key="iconsIndex">
      <input
        :name="`icon-${id}-${iconsIndex}`"
        :id="`icon-${id}-${iconsIndex}`"
        :value="icon"
        type="radio"
        class="icon-selector__input"
        v-model="content"
        @change="handleUpdate"
      >
      <label
        :for="`icon-${id}-${iconsIndex}`"
        class="icon-selector__label"
        v-html="getIcon(icon)"
      ></label>
    </div>
  </div>
</template>

<script>
export default {
  props: ['id', 'field'],

  data() {
    return {
      content: this.field.value,
      icons: [
        'experiences',
        'accommodations',
        'bag-plus',
        'italy',
      ],
    };
  },

  methods: {
    handleUpdate(event) {
      this.$emit('field-update', this.field.key, event.currentTarget.value);
    },

    getIcon(name) {
      return `<svg class="icon icon-${name}" aria-hidden="true"><use xlink:href="#icon-${name}"></use></svg>`;
    },
  },
}
</script>
